import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";

const DiagnosticEntryOnGoingCheckin = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection
        showTransportAutoEntriesDeliveryCodeWithComplete
      />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  );
}

export default DiagnosticEntryOnGoingCheckin;
